import Vue from 'vue'
import title from './fragments/title'
import { catalogDate } from '@/util/catalog'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const appointmentConfirmation = (data) => {
  const confirmation = data?.confirmation

  if (!confirmation) return ''

  let confirmationContent = ''

  if (confirmation.answered) {
    confirmationContent += `
      <h6 class="text-uppercase grey--text">
        ${translate(area + 'confirmation.confirmed')}
      </h6>
      <p class="body-2 mb-3">
        ${confirmation.confirmed != null
          ? confirmation.confirmed
            ? translate(area + 'yes')
            : translate(area + 'no')
          : '---'}
      </p>
    `

    if (confirmation.confirmed) {
      confirmationContent += `
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'confirmation.attendingToAppointment')}
        </h6>
        <p class="body-2 mb-3">
          ${confirmation.attending_to_appointment != null
            ? confirmation.attending_to_appointment
              ? translate(area + 'yes')
              : translate(area + 'no')
            : '---'}
        </p>
      `

      if (confirmation.keys_needs_authorization) {
        confirmationContent += `
          <h6 class="text-uppercase grey--text">
            ${translate(area + 'confirmation.keysNeedsAuthorization')}
          </h6>
          <p class="body-2 mb-3">
            ${confirmation.keys_needs_authorization != null
              ? confirmation.keys_needs_authorization
                ? translate(area + 'yes')
                : translate(area + 'no')
              : '---'}
          </p>
        `
      }

      if (confirmation.sent_at) {
        confirmationContent += `
          <h6 class="text-uppercase grey--text">
            ${translate(area + 'confirmation.sentAt')}
          </h6>
          <p class="body-2 mb-3">
            ${catalogDate(confirmation.sent_at)}
          </p>
        `
      }

      if (confirmation.answered_at) {
        confirmationContent += `
          <h6 class="text-uppercase grey--text">
            ${translate(area + 'confirmation.answeredAt')}
          </h6>
          <p class="body-2 mb-3">
            ${catalogDate(confirmation.answered_at)}
          </p>
        `
      }

      if (confirmation.accepted_date) {
        confirmationContent += `
          <h6 class="text-uppercase grey--text">
            ${translate(area + 'confirmation.acceptedDate')}
          </h6>
          <p class="body-2 mb-3">
            ${catalogDate(confirmation.accepted_date)}
          </p>
        `
      }

      confirmationContent += `
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'confirmation.observations')}
        </h6>
        <p class="body-2 mb-3">
          ${confirmation.comment != null ? confirmation.comment : '---'}
        </p>
      `
    }
  } else {
    confirmationContent += `
      <p class="body-2 mb-3 grey--text">
        ${translate(area + 'confirmation.notAnsweredYet')}
      </p>
    `
  }

  return `
    <details>
      ${title(translate(area + 'confirmationTitle'))}
      <content>
        ${confirmationContent}
      </content>
    </details>
  `
}

export default appointmentConfirmation
